<div class="flex items-center justify-center content-center flex-col min-h-[60vh] select-none">
  <div class="flex flex-col sm:flex-row sm:items-center text-center">
    <div class="flex-auto">
      <i class="pi pi-hammer text-[2.5rem]"></i>
      <p>{{ 'common.messages.underConstruction' | transloco }}</p>
    </div>
  </div>
</div>
